<template>
  <a-drawer
    :maskClosable="false"
    width="50%"
    :label-col="4"
    :wrapper-col="18"
    :visible="open"
    @close="
      onCloseConfirm(() => {
        open = false
      })
    "
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <LoadingPop v-if="showLoading" ref="LoadingPop" @ok="showLoading = false" />
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="是否在保修期内" prop="warrantyFlag">
        <a-radio-group button-style="solid" v-model="form.warrantyFlag">
          <a-radio-button :value="0"> 否 </a-radio-button>
          <a-radio-button :value="1"> 是 </a-radio-button>
        </a-radio-group>
      </a-form-model-item>

      <a-form-model-item label="维修清单" prop="repairItemList">
        <div class="repair-item-table-wrapper">
          <a-table
            :columns="columns"
            :data-source="form.repairItemList"
            :pagination="false"
            :bordered="true"
            size="small"
            :row-key="(record, index) => index"
          >
            <template slot="itemName" slot-scope="text, record, index">
              <a-form-model-item
                :prop="'repairItemList.' + index + '.itemName'"
                :rules="rules.itemName"
                style="margin-bottom: 0"
              >
                <a-select
                  v-model="record.itemName"
                  placeholder="请选择维修项名称"
                  style="width: 100%"
                  allow-clear
                  @change="(value) => handleItemNameChange(value, index)"
                >
                  <a-select-opt-group label="主机">
                    <a-select-option
                      v-for="(item, idx) in repairItemData.filter((i) => i.category === '主机')"
                      :key="'host-' + idx"
                      :value="item.name"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select-opt-group>
                  <a-select-opt-group label="配件">
                    <a-select-option
                      v-for="(item, idx) in repairItemData.filter((i) => i.category === '配件')"
                      :key="'part-' + idx"
                      :value="item.name"
                    >
                      {{ item.name }}
                    </a-select-option>
                  </a-select-opt-group>
                </a-select>
              </a-form-model-item>
            </template>
            <template slot="itemType" slot-scope="text, record, index">
              <a-form-model-item :prop="'repairItemList.' + index + '.itemType'" style="margin-bottom: 0">
                <a-select v-model="record.itemType" placeholder="请选择费用类型" style="width: 100%" allow-clear>
                  <a-select-option v-for="(item, idx) in itemTypeOptions" :key="idx" :value="item">
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </template>
            <template slot="unit" slot-scope="text, record">
              <span>{{ record.unit || '-' }}</span>
            </template>
            <template slot="quantity" slot-scope="text, record, index">
              <a-form-model-item
                :prop="'repairItemList.' + index + '.quantity'"
                :rules="rules.quantity"
                style="margin-bottom: 0"
              >
                <a-input-number
                  v-model="record.quantity"
                  placeholder="数量"
                  :min="1"
                  :precision="0"
                  style="width: 100%"
                />
              </a-form-model-item>
            </template>
            <template slot="unitPrice" slot-scope="text, record, index">
              <a-form-model-item
                :prop="'repairItemList.' + index + '.unitPrice'"
                :rules="rules.unitPrice"
                style="margin-bottom: 0"
              >
                <a-input-number
                  v-model="record.unitPrice"
                  placeholder="单价"
                  :min="0"
                  :precision="2"
                  style="width: 100%"
                />
              </a-form-model-item>
            </template>
            <template slot="totalPrice" slot-scope="text, record">
              <span>{{ getTotalPrice(record) }}</span>
            </template>
            <template slot="remark" slot-scope="text, record, index">
              <a-button type="link" size="small" @click="openRemarkModal(index)" style="padding: 0">
                {{
                  record.remark
                    ? record.remark.length > 10
                      ? record.remark.substring(0, 10) + '...'
                      : record.remark
                    : '添加备注'
                }}
              </a-button>
            </template>
            <template slot="action" slot-scope="text, record, index">
              <a-button
                type="danger"
                size="small"
                icon="delete"
                @click="removeRepairItem(index)"
                :disabled="form.repairItemList.length === 1"
              >
                删除
              </a-button>
            </template>
          </a-table>
          <div style="margin-top: 16px">
            <a-button type="dashed" icon="plus" @click="addRepairItem" style="width: 100%"> 添加维修项 </a-button>
          </div>
          <div class="total-summary" v-if="form.repairItemList.length > 0">
            <span
              >合计金额：<strong style="color: #f5222d; font-size: 16px">¥{{ getTotalAmount() }}</strong></span
            >
          </div>
        </div>
      </a-form-model-item>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>

    <!-- 备注编辑弹窗 -->
    <a-modal title="编辑备注" :visible="remarkModalVisible" @ok="saveRemark" @cancel="closeRemarkModal" :width="600">
      <a-textarea
        v-model="currentRemark"
        placeholder="请输入明细备注（如：配件型号）"
        :rows="4"
        :maxLength="200"
        allow-clear
      />
      <div style="margin-top: 8px; color: #999; font-size: 12px">
        已输入 {{ currentRemark ? currentRemark.length : 0 }} / 200 字
      </div>
    </a-modal>
  </a-drawer>
</template>

<script>
import { editRepairItem } from '@/api/fix/devRepair'

export default {
  name: 'RepairItem',
  data() {
    return {
      submitLoading: false,
      formTitle: '设备返修-维修清单',
      open: false,
      showLoading: false,
      // 备注弹窗相关
      remarkModalVisible: false,
      currentRemarkIndex: -1,
      currentRemark: '',

      // 表单参数
      form: {
        repairId: undefined,
        warrantyFlag: 0, // 默认不在保修期内
        repairItemList: [
          {
            itemName: '',
            itemType: '',
            quantity: 1,
            remark: '',
            unitPrice: 0,
            unit: '', // 单位
          },
        ],
      },

      rules: {
        warrantyFlag: [{ required: true, message: '请选择是否在保修期内', trigger: 'change' }],
        repairItemList: [
          {
            type: 'array',
            required: true,
            min: 1,
            message: '请至少添加一个维修项',
            trigger: 'change',
          },
        ],
        itemName: [{ required: true, message: '请选择维修项名称', trigger: 'change' }],
        quantity: [{ required: true, message: '请输入数量', trigger: 'blur', type: 'number' }],
        unitPrice: [{ required: true, message: '请输入单价', trigger: 'blur', type: 'number' }],
      },
      // 维修项数据（包含名称、单位、默认价格）
      repairItemData: [
        // 主机部分
        { name: '设备整体外壳(6部件)', unit: '套', defaultPrice: 65, category: '主机' },
        { name: '无刷电机总承', unit: '套', defaultPrice: 180, category: '主机' },
        { name: 'GS 动力泵总承', unit: '套', defaultPrice: 420, category: '主机' },
        { name: '扩散硅微型传感器', unit: '支', defaultPrice: 160, category: '主机' },
        { name: '21700电池包总承', unit: '套', defaultPrice: 115, category: '主机' },
        { name: '电控主板', unit: '套', defaultPrice: 345, category: '主机' },
        // 配件部分
        { name: '吸水管及前置过滤器', unit: '套', defaultPrice: 25, category: '配件' },
        { name: 'T型三通阀门', unit: '支', defaultPrice: 30, category: '配件' },
        { name: '出水黑管', unit: '根', defaultPrice: 45, category: '配件' },
        { name: '战术水袋', unit: '支', defaultPrice: 15, category: '配件' },
        { name: '设备黑箱包', unit: '支', defaultPrice: 30, category: '配件' },
        { name: '换新', unit: '个', defaultPrice: 0, category: '配件' },
        { name: '其他', unit: '个', defaultPrice: 0, category: '配件' },
        { name: '标识牌', unit: '套', defaultPrice: 15, category: '配件' },
        { name: '数据线', unit: '根', defaultPrice: 5, category: '配件' },
      ],
      // 费用类型选项
      itemTypeOptions: ['配件费', '人工费', '快递费', '其他'],
      columns: [
        {
          title: '维修项名称',
          dataIndex: 'itemName',
          width: '22%',
          scopedSlots: { customRender: 'itemName' },
        },
        {
          title: '费用类型',
          dataIndex: 'itemType',
          width: '15%',
          scopedSlots: { customRender: 'itemType' },
        },
        {
          title: '单位',
          dataIndex: 'unit',
          width: '10%',
          align: 'center',
          scopedSlots: { customRender: 'unit' },
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          width: '10%',
          align: 'center',
          scopedSlots: { customRender: 'quantity' },
        },
        {
          title: '单价',
          dataIndex: 'unitPrice',
          width: '12%',
          align: 'center',
          scopedSlots: { customRender: 'unitPrice' },
        },
        {
          title: '小计',
          dataIndex: 'totalPrice',
          width: '12%',
          align: 'center',
          scopedSlots: { customRender: 'totalPrice' },
        },
        {
          title: '备注',
          dataIndex: 'remark',
          align: 'center',
          width: '12%',
          scopedSlots: { customRender: 'remark' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '6%',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    onCloseConfirm(callback) {
      const that = this
      this.$confirm({
        title: '是否确认关闭？未保存的数据将丢失',
        onOk() {
          callback && callback()
          that.reset()
        },
        onCancel() {},
      })
    },

    // 取消按钮
    cancel() {
      this.onCloseConfirm(() => {
        this.open = false
      })
    },

    // 表单重置
    reset() {
      this.form = {
        repairId: undefined,
        warrantyFlag: 0,
        repairItemList: [
          {
            itemName: '',
            itemType: '',
            quantity: 1,
            remark: '',
            unitPrice: 0,
            unit: '',
          },
        ],
      }
      this.$refs.form && this.$refs.form.clearValidate()
    },

    /** 打开抽屉 */
    init(record) {
      this.reset()
      this.form.repairId = record.id
      this.open = true
    },

    // 处理维修项名称变化，自动填充单位和价格
    handleItemNameChange(value, index) {
      if (value && this.form.repairItemList[index]) {
        const selectedItem = this.repairItemData.find((item) => item.name === value)
        if (selectedItem) {
          this.form.repairItemList[index].unit = selectedItem.unit
          this.form.repairItemList[index].unitPrice = selectedItem.defaultPrice
        }
      } else {
        // 清空时重置
        this.form.repairItemList[index].unit = ''
        this.form.repairItemList[index].unitPrice = 0
      }
    },

    // 添加维修项
    addRepairItem() {
      this.form.repairItemList.push({
        itemName: '',
        itemType: '',
        quantity: 1,
        remark: '',
        unitPrice: 0,
        unit: '',
      })
    },

    // 删除维修项
    removeRepairItem(index) {
      if (this.form.repairItemList.length > 1) {
        this.form.repairItemList.splice(index, 1)
      }
    },

    // 计算单行小计
    getTotalPrice(record) {
      if (record.quantity && record.unitPrice) {
        return (record.quantity * record.unitPrice).toFixed(2)
      }
      return '0.00'
    },

    // 计算合计金额
    getTotalAmount() {
      let total = 0
      this.form.repairItemList.forEach((item) => {
        if (item.quantity && item.unitPrice) {
          total += item.quantity * item.unitPrice
        }
      })
      return total.toFixed(2)
    },

    // 打开备注弹窗
    openRemarkModal(index) {
      this.currentRemarkIndex = index
      this.currentRemark = this.form.repairItemList[index].remark || ''
      this.remarkModalVisible = true
    },

    // 关闭备注弹窗
    closeRemarkModal() {
      this.remarkModalVisible = false
      this.currentRemarkIndex = -1
      this.currentRemark = ''
    },

    // 保存备注
    saveRemark() {
      if (this.currentRemarkIndex >= 0) {
        this.form.repairItemList[this.currentRemarkIndex].remark = this.currentRemark
      }
      this.closeRemarkModal()
    },

    /** 提交表单 */
    submitForm: function () {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          // 验证维修项列表
          const hasInvalidItem = this.form.repairItemList.some(
            (item) => !item.itemName || !item.quantity || item.quantity <= 0 || !item.unitPrice || item.unitPrice < 0
          )
          if (hasInvalidItem) {
            this.$message.warning('请完善所有维修项信息', 3)
            return false
          }

          this.submitLoading = true
          this.showLoading = true

          editRepairItem(this.form)
            .then((response) => {
              this.$message.success('保存维修清单成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .catch(() => {
              // 错误处理
            })
            .finally(() => {
              this.submitLoading = false
              this.showLoading = false
            })
        } else {
          const messages = Object.values(object).flatMap((errorArray) => errorArray.map((item) => item.message))
          this.showLoading = true
          this.$nextTick(() => {
            this.$refs.LoadingPop && this.$refs.LoadingPop.init(2, messages)
          })
          return false
        }
      })
    },
  },
}
</script>

<style scoped>
.bottom-control {
  position: absolute;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}

.repair-item-table-wrapper {
  width: 100%;
}

.repair-item-table-wrapper :deep(.ant-table) {
  font-size: 14px;
}

.repair-item-table-wrapper :deep(.ant-table-tbody > tr > td) {
  padding: 8px;
}

.repair-item-table-wrapper :deep(.ant-form-item) {
  margin-bottom: 0;
}

.total-summary {
  margin-top: 16px;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 4px;
  text-align: right;
  font-size: 14px;
}
</style>
